var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.banners),function(i){return _c('div',{key:i.src,staticClass:"img-div",attrs:{"id":"right-ad-banners"}},[_c('a',{staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.redirect(i.link)}}},[_c('img',{staticClass:"img-fluid bg-cover",attrs:{"src":i.src,"alt":"Image"}})])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }